import classNames from "classnames";
import { CountryCode } from "libphonenumber-js";
import { Fragment } from "react";

import { PhoneNumber } from "@/components/General/PhoneNumber/phoneNumber.component";
import { StoreDistanceComponent } from "@/components/Store/shared/storeDistance/storeDistance.component";
import { useGranite } from "@/redux/modules/value/translations/translations.provider";

import { StoreStatus } from "./storeStatus/storeStatus.component";

import "./storeCard.scss";

type StoreCardProps = {
    className?: string;
    isSelected?: boolean;
    isOpen: boolean;
    openClosesAt?: string;
    handleOnStoreCardClick?: () => void;
    name: string;
    distancePromise?: Promise<undefined | number>;
    addressLines: Array<string>;
    phone: string;
    countryCode?: CountryCode;
};

const StoreCard = ({
    className,
    isSelected,
    isOpen,
    openClosesAt,
    handleOnStoreCardClick,
    name,
    distancePromise,
    addressLines,
    phone,
    countryCode
}: StoreCardProps) => {
    const { t } = useGranite();
    const statusText = t(
        `form.searchstore.storeCard.status.${isOpen ? "open" : "closed"}`
    );
    return (
        <li
            className={classNames(
                "store-card",
                isSelected && "store-card--selected",
                !!handleOnStoreCardClick && "store-card--clickable",
                className
            )}
            onClick={handleOnStoreCardClick}
        >
            <p className={"store-card__title"}>
                {name}
                {distancePromise && (
                    <StoreDistanceComponent distancePromise={distancePromise} />
                )}
            </p>
            <StoreStatus
                isOpen={isOpen}
                openClosesAt={openClosesAt}
                statusText={statusText}
            />
            <p className={"m-0 mb-2"}>
                {addressLines.map((line, index) => {
                    return (
                        <Fragment key={index}>
                            <span>{line}</span>
                            {index < addressLines.length - 1 && <br />}
                        </Fragment>
                    );
                })}
            </p>
            <p className={"w-auto mb-0"}>
                <PhoneNumber
                    phoneNumber={phone}
                    ISOcountryCode={countryCode}
                    asLink={true}
                />
            </p>
        </li>
    );
};

export { StoreCard };
